import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import AssignSurveyModal from './AssignSurveyModal';
import SurveyEditor from './SurveyEditor';
import '../styles/SectionContent.css';
import '../styles/Surveys.css';

const Surveys = () => {
  const { surveyAssignments, surveyTemplates, saveSurveyTemplate, deleteSurveyTemplate } = useAuth();
  const [activeTab, setActiveTab] = useState('templates');
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showEditor, setShowEditor] = useState(false);
  const [editingSurvey, setEditingSurvey] = useState(null);

  const handleCreateSurvey = () => {
    setEditingSurvey(null);
    setShowEditor(true);
  };

  const handleEditSurvey = (survey) => {
    setEditingSurvey(survey);
    setShowEditor(true);
  };

  const handleSaveSurvey = (survey) => {
    saveSurveyTemplate(survey);
    setShowEditor(false);
    setEditingSurvey(null);
  };

  const handleDeleteSurvey = (surveyId) => {
    if (window.confirm('Are you sure you want to delete this survey template?')) {
      deleteSurveyTemplate(surveyId);
    }
  };

  return (
    <div className="section-content">
      <div className="section-header">
        <h2>Survey Templates</h2>
        <div className="survey-actions">
          <button 
            className="primary-btn" 
            onClick={() => setShowAssignModal(true)}
            style={{ marginRight: '10px' }}
          >
            + Assign Survey
          </button>
          <button 
            className="primary-btn" 
            onClick={handleCreateSurvey}
          >
            + Create Survey
          </button>
        </div>
      </div>
      
      <div className="templates-grid">
        {surveyTemplates.map((template) => (
          <div key={template.id} className="template-card">
            <div className="template-header">
              <h3>{template.name}</h3>
              <div className="template-actions">
                <button className="edit-btn" onClick={() => handleEditSurvey(template)}>✏️</button>
                <button className="delete-btn" onClick={() => handleDeleteSurvey(template.id)}>🗑️</button>
              </div>
            </div>
            <p className="template-description">{template.description}</p>
            <div className="template-meta">
              <span className="question-count">{template.questions?.length || 0} questions</span>
              <span className="time-estimate">{template.estimatedTime}</span>
            </div>
            <div className="template-footer">
              <span className="category">{template.category}</span>
              <span className="last-updated">Updated {new Date(template.updatedAt).toLocaleDateString()}</span>
            </div>
          </div>
        ))}
      </div>

      {showAssignModal && (
        <AssignSurveyModal onClose={() => setShowAssignModal(false)} />
      )}

      {showEditor && (
        <SurveyEditor
          survey={editingSurvey}
          onSave={handleSaveSurvey}
          onClose={() => {
            setShowEditor(false);
            setEditingSurvey(null);
          }}
        />
      )}
    </div>
  );
};

export default Surveys;
